import { useEffect, useState } from "react";

import api from "../utils/api/axiosInstance";

const useCommunitySummary = ({ productId, useCase = null, refreshKey = 0 }) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!productId) return undefined;
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const res = await api.get(`/products/${productId}/community-summary`, {
          params: useCase ? { useCase } : undefined,
        });
        if (!cancelled) setSummary(res?.data || null);
      } catch {
        if (!cancelled) setSummary(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [productId, useCase, refreshKey]);

  return { summary, loading };
};

export default useCommunitySummary;
